import type { Prototype } from "../prototype-types";

export const martinSitarPrototypes: Prototype[] = [
  {
    id: "brand-shop-page-2",
    name: "Brand Shop Page 2.0",
    path: "/ms/brand-shop-page-2",
    description: "Brand shop page 2.0 redesign exploration",
    owner: "Martin",
    createdAt: "2026-03-09",
    lastUpdated: "2026-04-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/8f456c0f8e37d64e865520c42536abf533a693b41cfc2f53404ccf7bd5d01205.png",
    creationTool: "claude-code",
  },
  {
    id: "self-serve-nudges",
    name: "Self serve nudges",
    path: "/ms/faire/products",
    description:
      "Product nudges and recommendations for brands on the products page. Features multiple banner concepts including Analytics Banner, Recommended For You, and Recommended For You V3 with expandable content and actionable insights.",
    owner: "Martin",
    createdAt: "2026-01-08",
    lastUpdated: "2025-11-14",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/4a2d13a9a1748b58c7ee097af0280429f841fd458a2dcb3f1448228ee4614b12.png",
    creationTool: "claude-code",
  },
  {
    id: "brand-analytics-2.0",
    name: "Brand Analytics 2.0",
    path: "/ms/faire/analytics",
    description:
      "Updated analytics dashboard for brands with enhanced metrics, revenue trends, top products, and customer insights. Features modern UI with interactive charts and performance summaries. Includes Version 2 with new card-based layout and metric displays.",
    owner: "Martin",
    createdAt: "2024-12-02",
    lastUpdated: "2026-01-12",
    surfaceArea: "Brand",
    category: "template",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/16e44006a1977c9058958974760a41aedf750aadd11011f608196a55dd0366a1.png",
    creationTool: "cursor",
  },
  {
    id: "messages",
    name: "Messages",
    path: "/ms/faire/messages",
    description:
      "Messaging interface for brands to communicate with retailers. Features conversation list, message threads, search, and real-time messaging capabilities.",
    owner: "Martin",
    createdAt: "2024-12-04",
    lastUpdated: "2026-01-08",
    surfaceArea: "Brand",
    category: "template",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/adb2c46621c6644eb16703c0d2a6511205b3fe5ec7844b407e7be4bdceb174b5.png",
    creationTool: "cursor",
  },
];
